import classNames from 'classnames';
import React, { ComponentPropsWithRef, FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { useActiveMonth, useDateFormat } from '../../hooks';

export type CalendarHeaderProps = {
    className?: string;
} & Omit<ComponentPropsWithRef<'header'>, 'className'>;

export const CalendarHeader: FunctionComponent<CalendarHeaderProps> = ({
    className,
    ...headerProps
}) => {
    const month = useActiveMonth();
    const label = useDateFormat(month.range.from, { month: 'long', year: 'numeric' });
    return (
        <header {...headerProps} className={classNames(styles.header, className)}>
            {label}
        </header>
    );
};
